import React from 'react';
import { PageChat } from '../PageChat/PageChat';
import { DefaultLayout } from './DefaultLayout';
import { LayoutSegment } from './LayoutSegment';
var PageChatLayout = function (props) { return (React.createElement(DefaultLayout, null,
    React.createElement(LayoutSegment, { label: "main" },
        React.createElement(PageChat, null)))); };
export default PageChatLayout;
